import React from "react";
import {Skeleton} from "antd";

const SkeletonLoader = () => {
    return (
        <div className="row">
            {[...Array(3)].map((data, index) => (
                <div key={index + 1} className="col-lg-4">
                    <div className="card mb-5 mb-lg-0">
                        <div className="card-body">
                            <Skeleton active/>
                        </div>
                    </div>
                </div>
            ))}

        </div>
    )
}

export {SkeletonLoader}